// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2jPP9","countryHighlight":"style_countryHighlight__1fkAj","legend":"style_legend__3NJW-"};